export default __webpack_public_path__ + "static/media/IMG_4555-min.3ba90909.JPG";